import { from, of } from 'rxjs'
import { catchError, switchMap, map, mergeMap, filter } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { RootEpic } from '../types'
import { getAllInstrumentsFailure, getAllInstrumentsRequest, getAllInstrumentsSuccess, setAuthToken } from '../actions'

export const getAllInstrumentsEpic: RootEpic = (action$, state$, { fetchAssets }) => {
  return action$.pipe(
    filter(isActionOf(getAllInstrumentsRequest)),
    switchMap(() => {
      const token = state$.value.app.authToken as string

      return from(fetchAssets({ token, limit: 1, page: 1 })).pipe(
        mergeMap((firstResponse) => {
          const totalItems = Math.max(firstResponse.meta?.totalItems || 0, 0)
          const limit = Math.max(totalItems, 1)
          return from(fetchAssets({ token, limit, page: 1 })).pipe(
            map((response) => getAllInstrumentsSuccess(response.items || [])),
          )
        }),
        catchError((err) => of(getAllInstrumentsFailure(err))),
      )
    }),
  )
}

export const triggerAssetsFetchOnAuthEpic: RootEpic = (action$) => {
  return action$.pipe(
    filter(isActionOf(setAuthToken)),
    map(() => getAllInstrumentsRequest()),
  )
}

export default [getAllInstrumentsEpic, triggerAssetsFetchOnAuthEpic]
